import React from 'react';
import { Analytics } from '@vercel/analytics/react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import ScrollToTop from './components/ScrollToTop';
import { LiveStreamProvider } from './contexts/LiveStreamContext';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Sermons from './pages/Sermons';
import Contact from './pages/Contact';
import Give from './pages/Give';
import Announcements from './pages/Announcements';
import PastorDetail from './pages/PastorDetail';

const App: React.FC = () => {
  return (
    <Router>
      <ScrollToTop />
      <LiveStreamProvider>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/pastor/:pastorId" element={<PastorDetail />} />
            <Route path="/services" element={<Services />} />
            <Route path="/sermons" element={<Sermons />} />
            <Route path="/announcements" element={<Announcements />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/give" element={<Give />} />
          </Routes>
        </Layout>
      </LiveStreamProvider>
      <Analytics />
    </Router>
  );
};

export default App;

